import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { SpecificSearchToneRequest } from '../api/search/specificsearchtone/specificsearchtonerequest';
import { SpecificSearchToneResponse, SpecificSearchToneResponseDtoImpl } from '../api/search/specificsearchtone/specificsearchtoneresponse';
import { SpecificSearchToneBuilder } from '../dto/specificsearchtone/specificsearchtonebuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class SpecificSearchToneAPIProcessorImpl extends APIProcessorImpl<SpecificSearchToneRequest, SpecificSearchToneResponse>
{
    private LOGGER: Logger = LogManager.getLogger(SpecificSearchToneAPIProcessorImpl.name);
    execute(request: SpecificSearchToneRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new SpecificSearchToneResponseDtoImpl(APIFeatures.SPECIFIC_SEARCH_TONE, "Specific Search Tone Success");
                let specificSearchToneResponse = new SpecificSearchToneBuilder(responseMapper.getResponseMap(),this.getContext()).buildAll();

                response.setSpecificSearchToneDto(specificSearchToneResponse);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SpecificSearchToneResponseDtoImpl(APIFeatures.SPECIFIC_SEARCH_TONE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SpecificSearchToneResponseDtoImpl(APIFeatures.SPECIFIC_SEARCH_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new SpecificSearchToneResponseDtoImpl(APIFeatures.SPECIFIC_SEARCH_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
     
            this.getAPIFailure(new SpecificSearchToneResponseDtoImpl(APIFeatures.SPECIFIC_SEARCH_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/specificsearchtoneapiprocessor.tsx